import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Modal, notification, Row, Spin, Upload } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { RootDispatch } from '../../app/store'
import React from 'react'
import styles from './putstorage.module.css'
import { getBindMSFXSubmitAsync } from './putstorageSlice'
import { selectUserId, selectUserName } from '../../app/applicationSlice'

export const NotActivatedYetModal = (props: {
  visible?: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const [buttonFlag, setButtonFlag] = useState(0)

  const [buttonLoading, setButtonLoading] = useState<boolean>(false)

  useEffect(() => {
    if (props?.visible) {
      setButtonFlag(0)
    }
  }, [props.visible])

  // 获取Modal标题
  const getModalTitle = () => {
    if (buttonFlag == 0) return '温馨提示'
    if (buttonFlag == 1) return '码上放心开通'
    return '绑定码上放心'
  }

  // 获取确定按钮文字
  const getOkText = () => {
    if (buttonFlag == 0) return '去开通'
    if (buttonFlag == 2) return '绑定'
    return ''
  }

  return (
    <>
      <Modal
        width={600}
        title={getModalTitle()}
        visible={props.visible}
        maskClosable={false}
        confirmLoading={buttonLoading}
        okText={getOkText()}
        footer={buttonFlag == 1 ? null : undefined}
        centered
        className={styles.roundedModal}
        onOk={(values: any) => {
          if (buttonFlag == 2) {
            // 第三步：绑定
            form.validateFields().then((values) => {
              const params = {
                status: 0,
                entId: values?.entId,
              }
              setButtonLoading(true)
              dispatch(getBindMSFXSubmitAsync(params))
                .then(unwrapResult)
                .then((res: any) => {
                  notification.success({
                    message: '绑定成功',
                  })
                  props.onOk()
                })
                .finally(() => {
                  setButtonLoading(false)
                  props.onOk()
                  form.resetFields()
                  setButtonFlag(0)
                })
            })
          } else if (buttonFlag == 0) {
            // 第一步：去开通 -> 跳转到第二步
            setButtonFlag(1)
          }
        }}
        onCancel={() => {
          setButtonFlag(0)
          props.onCancel()
        }}
        destroyOnClose
      >
        {/* 第一步：温馨提示 */}
        {buttonFlag == 0 && (
          <div style={{ padding: '0 20px' }}>
            <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>本功能需要开通对接码上放心平台，请先去开通</p>
            <p style={{ marginBottom: '8px' }}>开通码上放心对接后，系统可以为您实现：</p>
            <p style={{ marginBottom: '8px' }}>
              1、<span style={{ color: '#1890ff', fontWeight: 'bold' }}>一键获取</span> 供应商入库单并批量入库，告别繁琐的手动录入。
            </p>
            <p style={{ marginBottom: '8px' }}>
              2、<span style={{ color: '#1890ff', fontWeight: 'bold' }}>一键获取</span> 所有药品追溯码，防止错扫漏扫，同时支持扫描追溯码销售药品。
            </p>
            <p style={{ marginBottom: '8px' }}>
              3、<span style={{ color: '#1890ff', fontWeight: 'bold' }}>自动转换</span> 自动转换中大包装追溯码的小追溯码，效率翻倍。
            </p>
          </div>
        )}

        {/* 第二步：选择入驻状态 */}
        {buttonFlag == 1 && (
          <div
            style={{
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '400px',
                height: '66px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                padding: '0 10px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#1890ff'
                e.currentTarget.style.backgroundColor = '#f0f5ff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#d9d9d9'
                e.currentTarget.style.backgroundColor = 'transparent'
              }}
              onClick={() => {
                window.open('https://www.mashangfangxin.com/', '_blank')
              }}
            >
              <p style={{ fontSize: '16px', margin: 0 }}>没有入驻或绑定，先去入驻</p>
            </div>
            <div
              style={{
                width: '400px',
                height: '66px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                padding: '0 10px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#1890ff'
                e.currentTarget.style.backgroundColor = '#f0f5ff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#d9d9d9'
                e.currentTarget.style.backgroundColor = 'transparent'
              }}
              onClick={() => {
                setButtonFlag(2)
              }}
            >
              <p style={{ fontSize: '16px', margin: 0 }}>已入驻并完成绑定，进入下一步</p>
            </div>
            <p style={{ textAlign: 'center', color: '#027AFF', fontSize: '14px' }}>
              可联系客服获取开通操作手册
            </p>
          </div>
        )}

        {/* 第三步：绑定码上放心 */}
        {buttonFlag == 2 && (
          <>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px', fontWeight: 'bold' }}>码上放心上的企业唯一标识</p>
              <Form form={form}>
                <Form.Item
                  name="entId"
                  rules={[{ required: true, message: '请输入企业唯一标识' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="请输入企业唯一标识" />
                </Form.Item>
              </Form>
            </div>
            {/* <div style={{ marginTop: '24px' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '12px' }}>绑定步骤：</p>
              <div style={{ lineHeight: '1.5' }}>
                <p style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold' }}>一、入驻：</span>
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '8px' }}>
                  用户携带营业执照/营业执照等资料去
                  <a
                    onClick={() => {
                      window.open('https://www.mashangfangxin.com/', '_blank')
                    }}
                    style={{ color: '#1890ff', cursor: 'pointer' }}
                  >
                    码上放心平台入驻
                  </a>
                </p>
                <p style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold' }}>二、绑定API：</span>
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '8px' }}>
                  登录码上放心后台，进入【任务中心】-【API服务】-点击绑定API，填入相关信息：
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '4px' }}>2.1、AppKey填写 35256426</p>
                <p style={{ marginLeft: '25px', marginBottom: '4px' }}>
                  2.2、AppKey归属情况，选择由服务商提供的AppKey
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '4px' }}>
                  2.3、AppKey授权的使用场景：全选
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '12px' }}>
                  2.4、接口报错通知人信息：自行填写
                </p>
                <p style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold' }}>三、绑定好医点：</span>
                </p>
                <p style={{ marginLeft: '25px', marginBottom: '8px' }}>
                  后台进入【基础信息管理】-【企业信息管理】 获取企业唯一标识，填写到好医点平台进行绑定。
                </p>
              </div>
            </div> */}
          </>
        )}
      </Modal>
    </>
  )
}
